import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../admin/api';
import { useLang } from '../i18n/LanguageContext';

/**
 * Fire-and-forget visit ping on every route change. Skips admin pages.
 */
const VisitTracker = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    api.post('/api/track', {
      path: pathname,
      referrer: typeof document !== 'undefined' ? document.referrer : '',
      locale: lang,
    }).catch(() => { /* ignore failures */ });
  }, [pathname, lang]);

  return null;
};

export default VisitTracker;
